/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Label } from "reactstrap";

const DataLabel = ({
  title,
  value,
  placeholder = "Unknown"
}) => {
  return (
    <Label className="m-2" tag="h6">
      <span>{title}: </span>
      {value ? (
        <strong>{value}</strong>
      ) : (
        <span className="text-muted">{placeholder}</span>
      )}
    </Label>
  )
};

export default DataLabel;
